import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'

import { TConfirmDialogContentProps } from './models'

import styles from './ConfirmDialogContent.module.scss'

export const ConfirmDialogContent = ({
  confirmBtnText,
  content,
  hasComment,
  isOnlyApply,
  isApplyDisabled,
  onConfirm,
  onReject,
  rejectBtnText,
  title,
}: TConfirmDialogContentProps) => {
  const [comment, setComment] = useState('')

  const handleConfirm = useCallback(() => {
    onConfirm(comment)
  }, [comment, onConfirm])

  const handleReject = useCallback(() => {
    if (!isOnlyApply) {
      onReject(comment)
    }
  }, [comment, isOnlyApply, onReject])

  return (
    <div className={styles.content}>
      <div className={styles.title}>
        <h5 className={styles.title}>
          <Translation text={title} span />
        </h5>
      </div>
      <div>{typeof content === 'string' ? <Translation text={content} span /> : content}</div>
      {hasComment && (
        <Input
          classes={{
            root: styles.comment,
          }}
          type="text"
          label="Comment"
          onChange={setComment}
          value={comment}
        />
      )}
      <div className={styles.actions}>
        {!isOnlyApply && (
          <Button onClick={handleReject} color="danger">
            <Translation text={rejectBtnText} span />
          </Button>
        )}
        <Button onClick={handleConfirm} disabled={isApplyDisabled}>
          <Translation text={confirmBtnText} span />
        </Button>
      </div>
    </div>
  )
}
